/**************************************************
 * Nombre:       Dialogo_Dos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {Check} from '@mui/icons-material'
import {guardarObjLocal} from "../../Servicios/Local/guardarObjLocal";
import Formulario_Dos from "../Formularios/Formulario_Dos";


const Dialogo_Dos = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad, setEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Registrando progreso')

        let dox = await guardarDoc('leads', entidad)
        if (dox.res) {
            cerrar()
            guardarObjLocal({key: datos.nombreFunnel, obj: {paso: 3, id: dox.data}})
            realizado()
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }

    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Dos props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                    startIcon={<Check/>}
                >Seguir mi entrenamiento</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Dos